// TODO: Since there is no component associated with this file, this should not be in the `components` directory.

import { FC } from 'react';
import { StandardAddress, User } from 'lib/home/generated/types/api';

export interface EditProfileFormValues {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  address: {
    first_name: string;
    last_name: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    postal_code: string;
  };
  passwords: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  };
}

export const ProfileEditSection: FC<{ title: string }> = ({ title, children }) => (
  <div className="profile-edit-section md:flex gap-4">
    <h3 className="flex-1">{title}</h3>
    <div className="profile-edit-section flex-[2] lg:flex-1">{children}</div>
  </div>
);

export const isAddressUpdated = (values: EditProfileFormValues, defaultAddress: StandardAddress): boolean => {
  const { address } = values;

  return (
    address.first_name !== defaultAddress.first_name ||
    address.last_name !== defaultAddress.last_name ||
    address.line1 !== defaultAddress.line1 ||
    address.line2 !== defaultAddress.line2 ||
    address.city !== defaultAddress.city ||
    address.state !== defaultAddress.state ||
    address.postal_code !== defaultAddress.postal_code
  );
};

export const isBasicInfoUpdated = (
  values: EditProfileFormValues,
  me: Pick<User, 'first_name' | 'last_name' | 'email' | 'phone'>
): boolean => {
  return (
    values.first_name !== me.first_name ||
    values.last_name !== me.last_name ||
    values.email !== me.email ||
    values.phone !== me.phone
  );
};

export const isPasswordUpdated = (values: EditProfileFormValues): boolean => {
  const { passwords } = values;

  return passwords.new_password !== '' && passwords.confirm_password !== '';
};
